var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 52,
    viewBox: "0 0 54 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2398 6.42205C21.9919 2.56994 26.6783 0 32.0333 0C40.2009 0 46.8874 5.99146 47.3672 13.5412C51.0876 15.4275 53.6407 19.1291 53.6407 23.3738C53.6407 25.9319 52.8066 28.6324 51.2633 30.7404C49.7114 32.8601 47.2893 34.5539 44.1537 34.5539H44.1496L35.7726 34.5222C34.6539 34.518 33.7506 33.6638 33.7551 32.6143C33.7596 31.5648 34.6702 30.7174 35.789 30.7216L44.1537 30.7533C44.155 30.7533 44.1562 30.7533 44.1575 30.7533C45.5783 30.7519 46.8853 30.0071 47.9237 28.5887C48.9716 27.1574 49.5893 25.218 49.5893 23.3738C49.5893 20.2871 47.5264 17.6102 44.6198 16.5246L43.3434 16.0478V14.4107C43.3434 8.55572 38.2745 3.80061 32.0333 3.80061C27.6577 3.80061 23.8733 6.1328 21.9774 9.52815L21.1505 11.009L19.4794 10.4284C18.7576 10.1776 18.0508 10.04 17.2795 10.04C14.3261 10.04 11.8658 12.1068 11.4892 14.8148L11.3204 16.0292L10.0717 16.3866C6.90823 17.292 4.55138 20.0915 4.55138 23.3738C4.55138 27.3104 7.71958 30.6266 11.1011 30.6266H11.1107L18.2777 30.69C19.3964 30.6999 20.2947 31.5587 20.2842 32.6082C20.2736 33.6576 19.3582 34.5004 18.2395 34.4905L11.091 34.4272C4.88962 34.4211 0.5 28.809 0.5 23.3738C0.5 18.7754 3.51327 14.8362 7.71666 13.1529C8.83914 9.16209 12.702 6.23934 17.2795 6.23934C17.9677 6.23934 18.6185 6.30505 19.2398 6.42205Z",
    fill: "#B08C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0701 22.1387C28.1889 22.1387 29.0958 22.9895 29.0958 24.039V49.028C29.0958 50.0775 28.1889 50.9283 27.0701 50.9283C25.9514 50.9283 25.0444 50.0775 25.0444 49.028V24.039C25.0444 22.9895 25.9514 22.1387 27.0701 22.1387Z",
    fill: "#B08C3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4184 39.4838C17.208 38.7404 18.4906 38.7382 19.2831 39.479L28.6351 48.2204C29.4276 48.9611 29.4299 50.1644 28.6402 50.9078C27.8506 51.6513 26.568 51.6534 25.7755 50.9127L16.4235 42.1713C15.631 41.4305 15.6287 40.2273 16.4184 39.4838Z",
    fill: "#B08C3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8494 39.5077C38.6434 40.2471 38.6481 41.4503 37.8599 42.1952L28.643 50.9049C27.8548 51.6497 26.5722 51.6541 25.7782 50.9147C24.9843 50.1753 24.9796 48.9721 25.7678 48.2273L34.9847 39.5176C35.7729 38.7727 37.0555 38.7683 37.8494 39.5077Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.5a0a513c1c04c9b33e2c728bc5575767.svg";
export { ForwardRef as ReactComponent };